export default __webpack_public_path__ + "static/media/visa_heika.6751d175.png";